import React from 'react';
import { Navbar } from '../components/Navbar';
import { TrustBar } from '../components/TrustBar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { OwnerFinderHero } from '../components/owner-finder/OwnerFinderHero';
import { OwnerFinderSearch } from '../components/owner-finder/OwnerFinderSearch';
import { OwnerFinderWorkflow } from '../components/owner-finder/OwnerFinderWorkflow';
import { OwnerFinderProductTour } from '../components/owner-finder/OwnerFinderProductTour';
import { OwnerFinderFields } from '../components/owner-finder/OwnerFinderFields';
import { OwnerFinderDemo } from '../components/owner-finder/OwnerFinderDemo';
import { OwnerFinderComparison } from '../components/owner-finder/OwnerFinderComparison';
import { OwnerFinderPricing } from '../components/owner-finder/OwnerFinderPricing';
import { OwnerFinderUseCases } from '../components/owner-finder/OwnerFinderUseCases';
import { OwnerFinderFAQ } from '../components/owner-finder/OwnerFinderFAQ';
import { OwnerFinderCta } from '../components/owner-finder/OwnerFinderCta';
import { DatabaseIcon, ScaleIcon, BriefcaseIcon } from 'lucide-react';
const ownerFinderFeatures = [{
  title: 'Plumbing contacts database',
  description: 'Access plumbing contractors with verified contact info.',
  href: 'https://openmart.com/data/plumbing',
  cta: 'Explore plumbers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Dentist contacts database',
  description: 'Find dental practices with contact information.',
  href: 'https://openmart.com/data/dentists',
  cta: 'Explore dentists',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Property management contacts database',
  description: 'Discover property managers with verified details.',
  href: 'https://openmart.com/data/property-management',
  cta: 'Explore property managers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Doctor contacts database',
  description: 'Access medical practices and physicians.',
  href: 'https://openmart.com/data/doctors',
  cta: 'Explore doctors',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Openmart vs ZoomInfo',
  description: 'Compare owner contact data coverage and pricing.',
  href: 'https://openmart.com/comparison/openmart-vs-zoominfo',
  cta: 'See comparison',
  type: 'Comparison',
  color: 'orange' as const,
  icon: ScaleIcon
}, {
  title: 'Clipboard Health case study',
  description: 'How Clipboard Health scales outreach with Openmart.',
  href: 'https://openmart.com/case-study/clipboard-health',
  cta: 'Read case study',
  type: 'Case Study',
  color: 'green' as const,
  icon: BriefcaseIcon
}];
export function OwnerFinder() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-6718">
      <Navbar data-id="element-6719" />
      <main data-id="element-6720">
        <OwnerFinderHero data-id="element-6721" />
        <TrustBar data-id="element-6722" />
        <OwnerFinderSearch data-id="element-6723" />
        <OwnerFinderWorkflow data-id="element-6724" />
        <OwnerFinderProductTour data-id="element-6725" />
        <OwnerFinderFields data-id="element-6726" />
        <OwnerFinderDemo data-id="element-6727" />
        <OwnerFinderComparison data-id="element-6728" />
        <OwnerFinderPricing data-id="element-6729" />
        <OwnerFinderUseCases data-id="element-6730" />
        <OwnerFinderFAQ data-id="element-6731" />
        <RelatedFeatures features={ownerFinderFeatures} data-id="element-6732" />
        <OwnerFinderCta data-id="element-6733" />
      </main>
      <Footer data-id="element-6734" />
    </div>;
}